import { Box, Button, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { InvoiceForm } from '@/components/forms/InvoiceForm'
import {
  shippingLineNameFromSearchParams,
  soaIdsFromSearchParams,
} from '@/lib/navigation/financialStatementsSearchParams'

export default function CreateInvoicePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const paramsShippingLineId = useParams<{ shippingLineId: string }>().shippingLineId

  const shippingLineName = shippingLineNameFromSearchParams(searchParams)
  const finalShippingLineId = paramsShippingLineId
  const selectedSoaIds = soaIdsFromSearchParams(searchParams)

  const handleSuccess = () => {
    if (finalShippingLineId) {
      navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
    } else {
      navigate('/shipping-lines')
    }
  }

  const handleCancel = () => {
    if (finalShippingLineId) {
      navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
    } else {
      navigate('/shipping-lines')
    }
  }

  if (selectedSoaIds.length === 0) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Text color={colors.textSecondary} mb={4}>
            Select at least one Statement of Account before generating an invoice.
          </Text>
          <Button size="sm" variant="outline" onClick={handleCancel}>
            Back to Financial Statements
          </Button>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Create Invoice
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Create a new Invoice
              {selectedSoaIds.length > 1
                ? ` from ${selectedSoaIds.length} Statements of Account`
                : ''}
            </Text>
          </CardHeader>
          <CardBody>
            <InvoiceForm
              selectedSoaIds={selectedSoaIds}
              registeredName={shippingLineName}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
